/**
 * Initializes the recently viewed section. Only works on once per page.
 * @param {Node} container section container element
 */
RecentlyViewed = function(container) {
  // Check for container
  if (!container) {
    console.log('Error. Recently viewed section must be provided a container in order to work.');
    return false;
  }

  //
  // Get data- attribute information.
  //

  // Get how many products to show variable.
  const DEFAULT_LIMIT = 6;

  // Get the data-limit value or set to default limit (6).
  const limit = container.dataset.limit ? container.dataset.limit : DEFAULT_LIMIT;

  const grid = container.dataset.grid;

  // Get the data-carousel value or set to false (boolean)
  const carousel = container.dataset.carousel ? container.dataset.carousel : false;

  // If data-carousel attribute is set to a string "true", then convert to the "true" boolean value otherwise return "false" boolean
  const carouselEnabled = (carousel === 'true');

  const wrapperId = container.dataset.wrapperId;

  //
  // Helper functions
  //

  /**
   * Callback function to reveal the entire section
   * @param  {String} wrapperId wrapper element
   * @todo use container instead of wrapper?
   */
  const revealOuterWrapper = (wrapperId = 'recently-viewed') => {

    // Bail if not wrapper Id
    if (!wrapperId) {
      console.log('Error. must provide a wrapperId as an argument.');
      return false;
    }

    // Get the wrapper element
    let wrapper = document.getElementById(wrapperId);

    // Bail if no wrapper element was found
    if (!wrapper) {
      console.log('Error. No wrapper element was found.');
      return false;
    }

    // If the fadeIn helper method is not available then simply
    // change to display block. Otherwise use the fadeIn helper
    // method to display the section.
    if (typeof WAU.Helpers.fadeIn === 'undefined') {
      wrapper.style.display = 'block';
    } else if (typeof WAU.Helpers.fadeIn === 'function') {
      WAU.Helpers.fadeIn(wrapper);
    }
  };


  /**
   * Initialize the Flickity carousel.
   * @todo pass in container instead of using querySelector
   */
  const initCarousel = (wrapperId) => {

    if (!wrapperId) {
      console.log('Error. Must provide a wrapper element to initialze the carousel on.');
      return false;
    }

    // Get the carousel element
    const carousel = document.getElementById(wrapperId);

    // Bail if it does not exists.
    if (!carousel) {
      console.log('Error. No carousel element for recently viewed products found!');
      return false;
    }

    // Get config object from data- attribute
    const flktyData = carousel.dataset.flickityConfig;

    // Convert to a JSON object
    const flktyOptions = JSON.parse(flktyData);

    // If there are more products to show than what the products per row or "grid" option then there is enough to wrapAround, show prevNext buttons.
    if (Shopify.RecordViewedProducts.getCount() > grid) {
      flktyOptions.wrapAround = true;
      flktyOptions.prevNextButtons = true;
      flktyOptions.draggable = true;
    };

    // Initiate Flickity
    new Flickity(carousel, flktyOptions);
  };

  /**
   * Functions to run when showRecentlyViewed is done
   * @param  {boolean} carousel  determine sif using in a carousel or not
   * @param  {node} container container element
   * @param  {string} wrapperId ID of the wrapper inside the container that displays the products
   * @return {[type]}           [description]
   * @todo add checks
   */
  const afterComplete = (carousel, container, wrapperId) => {

    revealOuterWrapper(container.id);

    // If carousel is enabled
    if (carousel === true) {

      // Initialize the carousel
      initCarousel(wrapperId, this.container);
    }

    // Re-initialize Quickview
    WAU.Quickshop.init();
    WAU.ProductGridVideo.init();
  };

  const viewedProduct = new ViewedProducts({
    howManyToShow: limit,
    wrapperId: wrapperId,
    onComplete: afterComplete.bind(this, carouselEnabled, container, wrapperId)
  });
}

document.querySelectorAll('[data-section-type="recently-viewed"]').forEach(function(container){
  const loader = new WAU.Helpers.scriptLoader();
  loader.load([jsAssets.flickity]).finally(() => {
    RecentlyViewed(container);
  });
});
